/**
 * RefineTwoBars component - renders a refine two bars icon as  SVG
 * @returns React component that renders the refine two bars icon
 */
const RefineTwoBarsIcon = () => {
  return (
    <svg
      width="21"
      height="16"
      viewBox="0 0 21 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0761 13.9998H1.00034C0.447754 13.9998 0 13.552 0 12.9999C0 12.4478 0.447754 12.0005 1.00034 12.0005H12.0761C12.4883 10.8354 13.5958 9.99976 14.9016 9.99976C16.2071 9.99976 17.315 10.8354 17.7272 12.0005H20.0001C20.5522 12.0005 21 12.4478 21 12.9999C21 13.552 20.5522 13.9998 20.0001 13.9998H17.7272C17.315 15.1648 16.2071 16 14.9016 16C13.5958 16 12.4883 15.1648 12.0761 13.9998ZM13.9018 12.9999C13.9018 13.552 14.3495 13.9998 14.9016 13.9998C15.4538 13.9998 15.9015 13.552 15.9015 12.9999C15.9015 12.4478 15.4538 12.0005 14.9016 12.0005C14.3495 12.0005 13.9018 12.4478 13.9018 12.9999ZM3.57611 4H1.00034C0.447754 4 0 3.55273 0 3.00012C0 2.448 0.447754 1.99976 1.00034 1.99976H3.57611C3.98831 0.835571 5.09622 0 6.40167 0C7.70709 0 8.81497 0.835571 9.22717 1.99976H20.0001C20.5522 1.99976 21 2.448 21 3.00012C21 3.55273 20.5522 4 20.0001 4H9.22717C8.81497 5.16418 7.70709 6.00012 6.40167 6.00012C5.09622 6.00012 3.98831 5.16418 3.57611 4ZM5.40176 3.00012C5.40176 3.55273 5.84952 4 6.40167 4C6.95377 4 7.40152 3.55273 7.40152 3.00012C7.40152 2.448 6.95377 1.99976 6.40167 1.99976C5.84952 1.99976 5.40176 2.448 5.40176 3.00012Z"
        fill="#00494F"
      />
    </svg>
  );
};

export default RefineTwoBarsIcon;
